export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'apply_doc.full_name', label: 'Student', sortable: true },
    { key: 'organization', label: 'Organization', sortable: true },
    { key: 'dc_type', label: 'Dc Type', sortable: true },
    { key: 'period', label: 'Period', sortable: true },
    { key: 'exam', label: 'Exam', sortable: true },
    { key: 'direction_name', label: 'Direction', sortable: true },
    { key: 'direction_mark', label: 'Direction mark', sortable: true },
    { key: 'is_certificate', label: 'Is certificate', sortable: true },
    { key: 'english_mark', label: 'English Mark', sortable: true },
    { key: 'is_accepted', label: 'Status', sortable: true },
  ]
  return {
    tableColumns,
  }
}
